import { type OnboardingDataDraft } from '@/modules/rulesEngine';

import { type CreateProfileFormValues } from '../schema/createProfileSchema';

// Form values → draft. Height is stored as total inches (Sparta:
// `feet * 12 + inches`); weight in lbs. gender/ethnicity pass through as their
// backend value (single-char gender, ethnicity slug).
export const mapFormValuesToDraft = (
  values: CreateProfileFormValues
): Partial<OnboardingDataDraft> => {
  return {
    height: Number(values.feet) * 12 + Number(values.inches),
    weight: Number(values.weight),
    gender: values.gender,
    ethnicity: values.ethnicity,
  };
};
